// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-messenger__icon {
    margin-top: 0.1rem;
    border-radius: 50%;
    cursor: pointer;
}

.contact-communication__channel-name-select {
    display: block;
}

.contact-communication-column {
    font-weight: 700;
    margin-top: 0.78rem;
    margin-bottom: 0.72rem;
    min-width: 4rem;
    max-width: 8rem;
    overflow: hidden;
    text-overflow: ellipsis;
}
    .contact-communication-column input.form-control {
        padding-bottom: 5px;
        height: auto;
        margin-top: 16px;
    }


.contact-communication-row.odd, .contact-communication-row__device-info.odd,
.contact-communication-row__device-info.odd button,
.contact-communication-row__device-info.odd .MuiCollapse-wrapperInner {
    background-color: #2ab7a922;
}

.contact-communication-row__device-info td {
    padding: 0;
    padding-bottom: 5px;
}

.device-accordion.MuiAccordion-root {
    box-shadow: none;
}

.device-accordion .MuiAccordionSummary-root {
    min-height: 32px !important;
    height: 32px;
    padding: 0 8px;
}

.device-accordion button.Mui-expanded {
    background-color: #2ab7a944 !important;
}

.MuiAccordionDetails-root.device-accordion__details {
    padding: 5px;
}

.device-accordion-details__properties-list {
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/contact-communications-list/contact-communication-item/ContactCommunicationItem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;IACI;QACI,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;IACpB;;;AAGJ;;;IAGI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb","sourcesContent":[".contact-messenger__icon {\r\n    margin-top: 0.1rem;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.contact-communication__channel-name-select {\r\n    display: block;\r\n}\r\n\r\n.contact-communication-column {\r\n    font-weight: 700;\r\n    margin-top: 0.78rem;\r\n    margin-bottom: 0.72rem;\r\n    min-width: 4rem;\r\n    max-width: 8rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n    .contact-communication-column input.form-control {\r\n        padding-bottom: 5px;\r\n        height: auto;\r\n        margin-top: 16px;\r\n    }\r\n\r\n\r\n.contact-communication-row.odd, .contact-communication-row__device-info.odd,\r\n.contact-communication-row__device-info.odd button,\r\n.contact-communication-row__device-info.odd .MuiCollapse-wrapperInner {\r\n    background-color: #2ab7a922;\r\n}\r\n\r\n.contact-communication-row__device-info td {\r\n    padding: 0;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.device-accordion.MuiAccordion-root {\r\n    box-shadow: none;\r\n}\r\n\r\n.device-accordion .MuiAccordionSummary-root {\r\n    min-height: 32px !important;\r\n    height: 32px;\r\n    padding: 0 8px;\r\n}\r\n\r\n.device-accordion button.Mui-expanded {\r\n    background-color: #2ab7a944 !important;\r\n}\r\n\r\n.MuiAccordionDetails-root.device-accordion__details {\r\n    padding: 5px;\r\n}\r\n\r\n.device-accordion-details__properties-list {\r\n    margin: 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
